import React, { useEffect, useState } from 'react'
import { useStateValue } from '../state'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'
import { history } from './App'
import { Order } from './Order'
import { BootstrapPaginator, LoadingSpinner } from '@CommonComponents'
import { OrderFilters } from './OrderFilters'

export const Orders = ({ coursenum, pageNum }) => {
  if (pageNum === undefined || isNaN(pageNum)) {
    pageNum = 1
  }
  const [currentState, dispatch] = useStateValue()
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const fetchOrders = async pageNum => {
      getQueryParams
      let resp = await client.get(
        endpoints.pageOrders({
          pageNum: pageNum,
          filterString: getQueryParams(),
        })
      )
      dispatch({
        type: 'updateOrderCount',
        payload: resp.data.totalOrderCount,
      })
      dispatch({
        type: 'updateOrders',
        payload: resp.data.orders,
      })
      setLoading(false)
    }
    fetchOrders(pageNum)
  }, [pageNum])

  const getQueryParams = () => {
    let params = new URLSearchParams()
    let filterKeys = Object.keys(currentState.filters)
    for (let i = 0; i < filterKeys.length; i++) {
      let key = filterKeys[i]
      if (currentState.filters[key] !== '') {
        params.append(key, currentState.filters[key])
      }
    }
    return params.toString()
  }

  const updatePageNum = ({ pageNum, queryParams }) => {
    history.push(
      `/account/admin_coupons.management/${coursenum}/?page_num=${pageNum}${
        queryParams ? '&' + queryParams : ''
      }`
    )
  }

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between mb-3">
        <h2 className="mb-2 mt-0 w-50">Orders</h2>
        <div className="mt-3 pointer w-50 text-right">
          <OrderFilters pageNum={pageNum} coursenum={coursenum} />
        </div>
      </div>
      {loading ? (
        <div className="text-center">
          <LoadingSpinner style={{ fontSize: '50px' }} />
        </div>
      ) : (
        <div>
          {currentState.orders.length > 0 ? (
            currentState.orders.map((order, i) => (
              <Order
                key={i}
                orderId={order.id}
                orderedCourse={order.coursenum}
                orderedCourseTitle={order.courseTitle}
                created={order.created}
                numCodes={order.numCodes}
                contactName={order.contactName}
                contactEmail={order.contactEmail}
                institution={order.institution}
                invoiceStatus={order.invoiceStatus}
                index={i}
                invoiceNum={order.invoiceNum}
                pmtDate={order.pmtDate}
              />
            ))
          ) : (
            <div>
              <h4>No access code orders exist</h4>
            </div>
          )}
        </div>
      )}
      <BootstrapPaginator
        itemCount={currentState.totalOrderCount}
        pageItemLimit={currentState.resultsPerPage}
        currentPageNum={pageNum}
        updatePageFunc={updatePageNum}
        updateFuncArgs={getQueryParams()}
      />
    </React.Fragment>
  )
}
